import React from "react"
export function HotDrinks(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M15 7.592c2.21.003 4 1.82 4 4.06 0 2.172-1.684 3.945-3.8 4.05l-.2.006v-1.014c1.657 0 3-1.362 3-3.043 0-1.62-1.249-2.944-2.824-3.037L15 8.61v-.003h-.5v5.58c0 .173-.01.343-.028.51H15v1.014h-.757c-.596 1.706-2.163 2.945-4.027 3.035L10 18.75H5.5c-2.414 0-4.384-1.928-4.495-4.349L1 14.187V8.102c0-.249.177-.456.41-.499l.09-.008H13v-.003h2zm-1.5 1.017H2v5.578c0 1.83 1.365 3.335 3.119 3.528l.189.016.192.005H10c1.869 0 3.395-1.485 3.495-3.355l.005-.194V8.609zM6.619.75l.765.653c-.678.816-.732 1.128-.447 1.722l.104.205c.445.872.407 1.548-.396 2.494l-.141.16-.735-.688c.6-.66.66-.912.436-1.393l-.097-.194c-.499-.968-.488-1.685.369-2.782L6.619.75zm2.365 0l.765.653c-.677.816-.731 1.128-.447 1.722l.104.205c.445.872.407 1.548-.396 2.494l-.141.16-.735-.688c.6-.66.66-.912.436-1.393l-.097-.194c-.499-.968-.488-1.685.369-2.782L8.984.75z"
        fill="currentColor"
        id="prefix__hot-drinks"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  )
}
